
// Used through the app to help string manipulations

// METHODS
// ---- Capitalize first letter of a text
export function capitalizeFirst(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}